/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MealDeliveryAliases {
  DELIVERING_MEALS = 'delivering-meals',
  DELIVERING_MEALS_ROUTE = 'delivering-meals-route',
  MEAL_DELIVERY_LAYOUT = 'meal-delivery-layout',
  MEAL_DELIVERY_PATIENT = 'meal-delivery-patient',
  MEAL_DELIVERY_PATIENT_ROUTE = 'meal-delivery-patient-route',
  SEARCH_PATIENT_MEAL_DELIVERY = 'search-patient-meal-delivery',
  SEARCH_PATIENT_MEAL_DELIVERY_ROUTE = 'search-patient-meal-delivery-route',
}
export { MealDeliveryAliases };
